var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('h1',{staticClass:"text-h6 px-3 pt-3"},[_vm._v(" "+_vm._s(_vm.$t('time_tracking.general.page_title'))+" ")]),_c('app-time-tracking-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }